module.exports = __webpack_public_path__ + "img/education_red_dot.7ada10fd.svg";